exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * Themings and color for POS app\n */\n.side-bar {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  min-width: 228px !important;\n  max-width: 280px !important;\n}\n.sidebar-margin {\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n.side-bar-container {\n  background-color: #eef3f7 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  z-index: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  border-right: 2px solid #e0e5e8 !important;\n}\n.side-bar-links {\n  text-decoration: none;\n  color: black;\n}\n.side-bar-links:hover {\n  color: black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/posSideBar.less
// module id = 3228
// module chunks = 0